import React, {useState} from 'react';
import {Choice} from '../types';
import {ActivityButton} from './ActivityButton';

type ButtonDropdownProps = {
    label: string;
    options: Choice[];
    isActive: boolean;
    onSelect: (value: string, choice?: Choice) => void;
    buttonClassName?: string;
    menuClassName?: string;
    containerClass?: string;
};

export const ButtonDropdown: React.FunctionComponent<ButtonDropdownProps> = ({
                                                                                 label,
                                                                                 isActive,
                                                                                 options,
                                                                                 onSelect,
                                                                                 buttonClassName,
                                                                                 menuClassName,
                                                                                 containerClass
                                                                             }) => {
    const [isShowing, setIsShowing] = useState<boolean>(false);

    const menuClasses = [
        'dropdown-menu',
        isShowing && 'show',
        menuClassName ? menuClassName : 'w-100'
    ]
        .filter(Boolean)
        .join(' ');

    const containerClasses = [
        'btn-group d-block',
        containerClass && containerClass
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={containerClasses}>
            <ActivityButton type="button"
                            isActive={isActive}
                            className={buttonClassName || 'btn btn-block btn-warning dropdown-toggle'}
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={() => {
                                setIsShowing(!isShowing);
                            }}
            >{label}
            </ActivityButton>
            <div className={menuClasses}>
                {options.map((choice: Choice, index: number) => (
                    <a key={index}
                       className="dropdown-item"
                       href="#"
                       onClick={(e) => {
                           e.preventDefault();
                           setIsShowing(false);
                           onSelect && onSelect(choice.value, choice);
                       }}>{choice.label}</a>
                ))}
            </div>
        </div>
    );
};